module.exports = __webpack_public_path__ + "static/media/6.65c303b9.JPG";